import { MutationHookOptions, useMutation } from '@apollo/client';

import mutation from './bulkRegisterAssetsMutation.graphql';

export const useBulkRegisterAssetsMutation = (
  opts?: MutationHookOptions<
    BulkRegisterAssetsMutation,
    BulkRegisterAssetsMutationVariables
  >,
) => {
  return useMutation<
    BulkRegisterAssetsMutation,
    BulkRegisterAssetsMutationVariables
  >(mutation, opts);
};
